import { Location } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  signal,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet, type ActivatedRouteSnapshot } from '@angular/router';
import BackButtonComponent from '@components/back-button/back-button.component';
import { filter, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, BackButtonComponent],
})
export class AuthWrapperComponent {
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private readonly destroyRef = inject(DestroyRef);
  readonly currentYear = signal(new Date().getFullYear());
  hideBackButton = false;

  constructor() {
    this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter(event => event instanceof NavigationEnd),
        startWith(null)
      )
      .subscribe(() => {
        const snapshot = this.router.routerState.snapshot;
        const route = snapshot.root;
        const data = this.getRouteData(route);

        this.hideBackButton = data['hideBackButton'] ?? false;
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private getRouteData(route: ActivatedRouteSnapshot): any {
    if (route.firstChild) {
      return this.getRouteData(route.firstChild);
    }
    return route.data;
  }

  back(): void {
    this.location.back();
  }
}
